import { useEffect, useState } from 'react';
import { triggerAriaMessage } from '../../Shared/a11yUtils';
import { useTranslation } from '../../hooks/useTranslation';
export default function useAutoLoading({ autoLoading, loading, onClick, }) {
    const [isLoading, setIsLoading] = useState(loading);
    const { t } = useTranslation('Shared');
    useEffect(() => {
        setIsLoading(loading);
    }, [loading]);
    const clickCallback = async (e) => {
        if (loading) {
            // In the loading state, the click event is directly disabled
            return;
        }
        if (autoLoading) {
            if (isLoading) {
                return;
            }
            try {
                setIsLoading(true);
                triggerAriaMessage(t('loading'));
                await onClick?.(e);
            }
            catch (err) {
                // eslint-disable-next-line no-console
                console.error(err);
            }
            setIsLoading(false);
        }
        else {
            void onClick?.(e);
        }
    };
    return [isLoading, clickCallback];
}
